import { Component, h, State } from '@stencil/core';
import state from '@ugc-store';
import { getReviewMoreImagesData, toSingleReviewInfo } from '@ugc-components/ugc-pdp-review/utils';
import { getReview } from '@ugc-api/review';

@Component({
  tag: 'ugc-review-mw-all-images-modal',
  styleUrl: 'ugc-review-mw-all-images-modal.scss',
  shadow: false,
})
export class UgcReviewMwAllImagesModal {
  @State() isDataLoading = false;

  handleScroll = async () => {
    try {
      const el = document.querySelector('.modal-content');
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 10) {
        if (!this.isDataLoading) {
          this.isDataLoading = true;
          await getReviewMoreImagesData();
          this.isDataLoading = false;
        }
      }
    } catch (e) {}
  };

  handleCancel = () => {
    state.isShowCustomerImagesModal = false;
  };

  handleShowDetailModal = async ({ reviewId, assetId }) => {
    state.activeImageReviewId = reviewId;
    state.activeImageAssetId = assetId;
    const data = (await getReview(state.activeImageReviewId)) || {};
    state.customerImagesDetailModalData = toSingleReviewInfo(data);
    state.isShowCustomerAllImagesDetailModal = true;
    state.isShowCustomerImagesModal = false;
  };

  render() {
    const {
      isShowCustomerImagesModal,
      reviewStaticLanguage: { IDS_LBL_REVIEW_IMAGES } = {},
      reviewImageListData: { items = [] },
    } = state;

    return (
      <ugc-drawer
        isShow={isShowCustomerImagesModal}
        modalTitle={IDS_LBL_REVIEW_IMAGES}
        isShowButton={false}
        handleCancel={this.handleCancel}
        handleScroll={this.handleScroll}
      >
        {isShowCustomerImagesModal && (
          <div class="p-24" style={{ minHeight: '75vh' }}>
            <div class="ugc-review-mw-all-images-modal-wrap">
              {items.map(item => (
                <img
                  key={item.assetId}
                  src={item.paths.m}
                  alt="image"
                  class="image-item border-1 border-solid border-gray-300 rounded-4 pointer"
                  onClick={() => this.handleShowDetailModal({ reviewId: item.reviewId, assetId: item.assetId })}
                />
              ))}
            </div>
          </div>
        )}
      </ugc-drawer>
    );
  }
}
